
export interface Founder {
  id: number;
  name: {
    en: string;
    ar: string;
  };
  role: {
    en: string;
    ar: string;
  };
  bio: {
    en: string;
    ar: string;
  };
  quote: {
    en: string;
    ar: string;
  };
  education: {
    en: string[];
    ar: string[];
  };
  social: {
    instagram?: string;
    linkedin?: string;
    twitter?: string;
  };
  image: string;
}

export const foundersData: Founder[] = [
  {
    id: 1,
    name: {
      en: "Shahd Abuhamda",
      ar: "شهد أبو حمدة"
    },
    role: {
      en: "Co-Founder & Content Lead",
      ar: "المؤسس المشارك ومسؤول المحتوى"
    },
    bio: {
      en: "Shahd is a storyteller and journalist who believes in the power of narrative to drive change. With her background in media and sustainable development, she leads the content creation for Palsustain, focusing on authentic stories that showcase Palestinian resilience and innovation.",
      ar: "شهد هي راوية قصص وصحفية تؤمن بقوة السرد في دفع التغيير. مع خلفيتها في الإعلام والتنمية المستدامة، تقود إنشاء المحتوى لـ بالسستين، مع التركيز على القصص الأصيلة التي تُظهر المرونة والابتكار الفلسطيني."
    },
    quote: {
      en: "Every Palestinian story of sustainability is an act of resistance and hope.",
      ar: "كل قصة فلسطينية عن الاستدامة هي فعل من أفعال المقاومة والأمل."
    },
    education: {
      en: ["MA in Media & Communications, Birzeit University", "BA in Journalism, Al-Quds University"],
      ar: ["ماجستير في الإعلام والاتصالات، جامعة بيرزيت", "بكالوريوس في الصحافة، جامعة القدس"]
    },
    social: {
      instagram: "shahd_storyteller",
      linkedin: "shahd-abuhamda",
      twitter: "shahd_stories"
    },
    image: "/lovable-uploads/d2860ec4-57c3-45c0-9db8-0df12af9bc0e.png"
  },
  {
    id: 2,
    name: {
      en: "Aseel Nasser",
      ar: "أسيل ناصر"
    },
    role: {
      en: "Co-Founder & Projects Coordinator",
      ar: "المؤسس المشارك ومنسق المشاريع"
    },
    bio: {
      en: "Aseel brings her expertise in environmental science and community organizing to Palsustain. She coordinates our field projects and partnerships, ensuring that our storytelling is connected to tangible sustainability initiatives on the ground.",
      ar: "تجلب أسيل خبرتها في العلوم البيئية وتنظيم المجتمع إلى بالسستين. تنسق مشاريعنا الميدانية والشراكات، مما يضمن أن رواية قصصنا مرتبطة بمبادرات الاستدامة الملموسة على أرض الواقع."
    },
    quote: {
      en: "Sustainability in Palestine isn't just about the environment—it's about our right to exist and thrive on our land.",
      ar: "الاستدامة في فلسطين ليست فقط متعلقة بالبيئة - بل هي حول حقنا في الوجود والازدهار على أرضنا."
    },
    education: {
      en: ["MSc in Environmental Management, University of Oxford", "BSc in Environmental Science, An-Najah National University"],
      ar: ["ماجستير في الإدارة البيئية، جامعة أكسفورد", "بكالوريوس في العلوم البيئية، جامعة النجاح الوطنية"]
    },
    social: {
      instagram: "aseel_enviroscience",
      linkedin: "aseel-nasser",
      twitter: "aseel_sustain"
    },
    image: "/lovable-uploads/6494c85c-e438-4cbe-bc63-bc2c8df9fb99.png"
  }
]
